import { render, staticRenderFns } from "./MixDrugManufacturing.vue?vue&type=template&id=1cb63086&scoped=true"
import script from "./MixDrugManufacturing.vue?vue&type=script&lang=js"
export * from "./MixDrugManufacturing.vue?vue&type=script&lang=js"
import style0 from "./MixDrugManufacturing.vue?vue&type=style&index=0&id=1cb63086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb63086",
  null
  
)

export default component.exports